import { request } from 'graphql-request';
import { APP, API_URL, EVENT_TOKEN } from 'appenv';

const CommonLocalizableString = `
  fragment CommonLocalizableString on LocalizableString {
    values(locales: $locales) {
      locale
      value
    }
  }
`;

const CommonLocalizableImage = `
  fragment CommonLocalizableImage on LocalizableImage {
    values(locales: $locales) {
      locale
      value {
        originalImageUrl
      }
    }
  }
`;

const CommonLocalizableVideo = `
  fragment CommonLocalizableVideo on LocalizableVideo {
    values(locales: $locales) {
      locale
      value {
        playbackUrl
      }
    }
  }
`;

const CommonLocalizableFile = `
  fragment CommonLocalizableFile on LocalizableFile {
    values(locales: $locales) {
      locale
      value {
        fileUrl
      }
    }
  }
`;

const NonQuestionContentElement = `
  fragment NonQuestionContentElement on BoothContentElement {
    __typename
    ... on BoothRichtextContentElement {
      contentRichtextHtml {
        ...CommonLocalizableString
      }
    }
    ... on BoothImageContentElement {
      image {
        ...CommonLocalizableImage
      }
    }
    ... on BoothVideoContentElement  {
      videoFile {
        ...CommonLocalizableVideo
      }
    }
    ... on BoothFileContentElement {
      file {
        ...CommonLocalizableFile
      }
    }
  }
`;

const CommonBoothTier = `
  fragment CommonBoothTier on BoothTier {
    __typename
    name {
      ...CommonLocalizableString
    }
  }
`;

const eventByTokenQuery = `
  ${CommonLocalizableString}
  ${CommonLocalizableImage}
  ${CommonLocalizableVideo}
  ${CommonLocalizableFile}
  ${CommonBoothTier}
  ${NonQuestionContentElement}

  query($eventToken: String!, $locales: [Locale!]!) {
    eventByToken(eventToken: $eventToken) {
      boothTiers {
        nodes {
          ...CommonBoothTier
        }
      }
      halls {
        nodes {
          id
          name {
            ...CommonLocalizableString
          }
          booths {
            nodes {
              id
              appliedDesignCodename
              appointmentBookingUrl
              website
              boothNumber
              name {
                ...CommonLocalizableString
              }
              logo {
                ...CommonLocalizableImage
              }
              tier {
                ...CommonBoothTier
              }
              categories {
                nodes {
                  id
                  name {
                    ...CommonLocalizableString
                  }
                }
              }
              designElements {
                nodes {
                  id
                  name
                  kind
                  color
                  image {
                    ...CommonLocalizableImage
                  }
                  video {
                    ...CommonLocalizableVideo
                  }
                  contentRichtextHtml {
                    ...CommonLocalizableString
                  }
                  thumbnailImage {
                    ...CommonLocalizableImage
                  }
                  pdf {
                    ...CommonLocalizableFile
                  }
                }
              }
              rootContentElement {
                tabs {
                  nodes {
                    title {
                      ...CommonLocalizableString
                    }
                    body {
                      nodes {
                        __typename
                        id
                        ...NonQuestionContentElement
                        ... on BoothQuestionContentElement {
                          question {
                            ...CommonLocalizableString
                          }
                          answer {
                            ...NonQuestionContentElement
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const eventByToken = (locales = ['en']): Promise<any> => {
  if (APP === 'jetro817') {
    return request(
      'https://api-virtual.eventxtra.com/graphql',
      eventByTokenQuery,
      {
        eventToken: 'gbtyes6dGZHmhdKTiu4RYxyw',
        locales,
      },
    ).then((result) => result.eventByToken);
  }

  return request(
    API_URL,
    eventByTokenQuery,
    {
      eventToken: EVENT_TOKEN,
      locales,
    },
  ).then((result) => result.eventByToken);
};

export default eventByToken;
